import axios from "../axios";

const confirmBankAccountApprove = async function (accessToken, uuid, bankAccountId) {
    try {
        const response = await axios.post('/bank-account/confirmBankAccountApprove', {
            bankAccountId
        }, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default confirmBankAccountApprove;
